var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCapitec(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 33,
    viewBox: "0 0 60 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M138.543 18.477V.71H.553v17.766h137.99z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M0 .4v31.163h40.37V.4z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E63934",
    d: "M43.437.79H21.76v9.093c0 3.246 2.657 5.883 5.904 5.883h11.334c4.059 0 7.38 3.321 7.38 7.38v8.595c7.862-1.3 13.883-7.705 13.883-15.355C60.261 7.808 52.69.789 43.437.789"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .54)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#00466E",
    d: "M34.467 16.5H23.17c-4.06 0-7.38-3.271-7.38-7.328V.399C7.014.9 0 7.71 0 15.965c0 8.58 7.572 15.598 16.825 15.598h23.547v-9.16c0-3.246-2.656-5.903-5.904-5.903",
    mask: "url(#d)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCapitec);
export default __webpack_public_path__ + "static/media/capitec.23042993cc7ebf39b69db343b0e02179.svg";
export { ForwardRef as ReactComponent };